module.exports = __webpack_public_path__ + "img/univelcity.cd31d59f.svg";